import React from 'react';
import { cx, FOCUS_RING } from '../components/styles';
import { useTour } from './TourContext';

/**
 * Replays the onboarding tour. Lives in page-header action slots (Support,
 * Profile) so a user who skipped the tour, or an account older than the
 * auto-start window, can still take it. Renders nothing when the tour is
 * already running — the card has its own controls.
 */
export const TakeTheTourButton: React.FC<{ className?: string }> = ({ className }) => {
  const { active, start } = useTour();
  if (active) return null;
  return (
    <button
      type="button"
      onClick={() => start('manual')}
      className={cx(
        'inline-flex items-center justify-center gap-2 rounded-lg border border-white/10 bg-white/5 px-4 py-2 text-sm font-medium text-white transition-colors hover:border-white/20 hover:bg-white/10',
        FOCUS_RING,
        className,
      )}
    >
      <svg
        className="h-4 w-4 text-[#60a5fa]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M10 8.5v7l5.5-3.5z" />
      </svg>
      Take the tour
    </button>
  );
};
